import type {
  ProductType,
  PurchaseWebContract,
  PurchaseWebTextValues,
} from '@xing-com/crate-common-graphql-types';
import type { GetCampaignQuery } from '@xing-com/crate-upsell-graphql';
import type { ContractPrice } from '@xing-com/crate-upsell-utils';
import { getContractPrice } from '@xing-com/crate-upsell-utils';

import { getDefaultContract } from './get-default-contract';

export type CampaignCardData = {
  campaignIdentifier: string;
  contract: PurchaseWebContract;
  endsAt?: string | null;
  price: ContractPrice;
  product: ProductType;
  textValues: PurchaseWebTextValues;
};

export const mapCampaignToCardData = (
  product: ProductType,
  campaign: GetCampaignQuery['results']
): CampaignCardData | null => {
  if (!campaign || campaign.contracts.length === 0) {
    return null;
  }

  const contract = getDefaultContract(campaign.contracts);

  return {
    campaignIdentifier: campaign.campaignIdentifier,
    contract,
    endsAt: campaign.endsAt,
    price: getContractPrice(contract),
    product,
    textValues: campaign.textValues,
  };
};
